import { sendAmplitudeData, setAmplitudeUserId } from './amplitude';
import { sendFirebaseEvent, setUserId } from './firebase';
import { sendGismartData } from './gismart';
import { sendLockerStudioData } from './lockerStudio';
import gismartEvents from './gismartEvents';

const isStage = process.env.REACT_APP_ENV === 'stage';

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
  const gismartEventName = gismartEvents[eventName];

  sendAmplitudeData(eventName, eventParams);
  sendFirebaseEvent(eventName, eventParams);
  sendGismartData(gismartEventName || eventName, eventParams);
  sendLockerStudioData(gismartEventName || eventName, eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
  setAmplitudeUserId(userId);
  setUserId(userId);
};

export const pushFBEvent = (data, eventId) => {
  if (window.fbq) {
    window.fbq('track', `Purchase${isStage ? '_test' : ''}`, data, {
      eventID: eventId,
    });
  }
};
